module.exports = __webpack_public_path__ + "img/img-fachai-fish.76039cb5.png";